import { FormattedMessage } from 'react-intl';
import WarningIcon from '@atlaskit/icon/core/warning';
import LockLockedIcon from '@atlaskit/icon/core/lock-locked';
import Link from '@atlaskit/link';
import { IconTile } from '@atlaskit/icon';

import IconWithContent from '../IconWithContent';
import { useInfo } from '../../../Flow/ConsentContextProvider';

const PrivacyPolicy = () => {
  const { client } = useInfo();
  const hasPrivacyPolicy = !!client?.appPrivacyPolicyLink;
  const Icon = hasPrivacyPolicy ? LockLockedIcon : WarningIcon;
  return (
    <IconWithContent
      text={
        <span>
          <FormattedMessage
            id="trello.privacyPolicy.atlassianObligation"
            defaultMessage="Atlassian's privacy policy is not applicable to the use of this app."
            description="Notice that Atlassian's privacy policy doesn't apply"
          />
          <br />
          {hasPrivacyPolicy ? (
            <FormattedMessage
              id="trello.privacyPolicy.policyLink"
              defaultMessage="Refer to the app developer's <policyLink>privacy policy</policyLink>."
              description="Links to the third party app's privacy policy link"
              values={{
                policyLink: (text) => (
                  <Link href={client?.appPrivacyPolicyLink!}>{text}</Link>
                ),
              }}
            />
          ) : (
            <FormattedMessage
              id="trello.privacyPolicy.noPolicyLink"
              defaultMessage="The app developer has not attached a privacy policy."
              description="The third party app did not provide a privacy policy"
            />
          )}
        </span>
      }
      icon={
        <IconTile icon={Icon} label="" appearance="gray" size="medium" />
      }
    />
  );
};

export default PrivacyPolicy;
